var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#A3A3AC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.117 14.31L24.446 7h-1.5l-5.495 6.348L13.062 7H8l6.637 9.599L8 24.265h1.5l5.803-6.703 4.635 6.703H25l-6.883-9.954zm-2.054 2.373l-.672-.955-5.35-7.606h2.303l4.318 6.138.672.956 5.613 7.978h-2.304l-4.58-6.51z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/x-twitter.6d7a3a20.svg";
export { SvgXTwitter as ReactComponent };